import { t } from '@lingui/core/macro'

import { useMemo } from 'react'
import Modal from 'react-bootstrap/Modal'
import { colorScheme } from '~/components/echarts/colors'
import { xAxisFormatter } from '~/components/echarts/formatters'
import { plainStackedTooltipFormatter } from '~/components/echarts/stacked_tooltip'

export default function ModalTooltip({ data, currentSeriesName, isTooltipOpened, closeTooltip }) {
  const { formatter, currency } = data

  const parsedData = useMemo(() => {
    const result = Object.entries(data.data)
      .map(([seriesName, values]) => {
        const entry = values.find(([date]) => date === currentSeriesName)
        if (entry) {
          return { name: seriesName, value: entry[1], color: null }
        }
        return null
      })
      .filter(Boolean)

    const total = data.total
      .map(([date, value]) => {
        if (date === currentSeriesName) {
          return { name: t`Total`, value, color: null }
        }
        return null
      })
      .filter(Boolean)

    const allSeriesData = result.concat(total)
    const colors = colorScheme(allSeriesData)
    return allSeriesData.map((item, index) => ({ ...item, color: colors[index] }))
  }, [data, currentSeriesName])

  const formatMonthYear = (dateString) => {
    const { format: xAxisFormat } = data.x
    return xAxisFormatter(xAxisFormat)(dateString)
  }

  return (
    <Modal show={isTooltipOpened} onHide={closeTooltip}>
      <Modal.Header closeButton>
        <Modal.Title>{formatMonthYear(currentSeriesName)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {plainStackedTooltipFormatter(currency, formatter)(formatMonthYear(currentSeriesName), parsedData)}
      </Modal.Body>
    </Modal>
  )
}
